export const MOBILE_BREAKPOINT = 600;
